module.exports = __webpack_public_path__ + "media/images/photo/Residential/Residential-01-0d1e423aaa06c2434aef9a90983b0ff7.png";